import { useEffect, useState } from 'react';

import type { ByfunnFrapiSearchResponse } from '../../types/frapi-types.js';
import type { Tag } from '../../../core/data-sources/frapi/data-types.js';

import { generateSearchQuery } from '../components/search/helpers.js';
import { useDebounce } from '../../../core/react/hooks/index.js';

export function useSearch(
  section: string | undefined = undefined,
  activeFilters: Tag[] = [],
  presetTerm = '',
  size = 20,
  page = 1,
) {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResult, setSearchResult] =
    useState<ByfunnFrapiSearchResponse | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (presetTerm) {
      setSearchTerm(presetTerm);
    }
  }, [presetTerm]);

  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  const sanitizeSearchQuery = (str: string) =>
    str.replace(/[@#$^&%*()=[\]\\/{}:<>?.]+/gi, '');

  useEffect(() => {
    (async () => {
      try {
        if (debouncedSearchTerm.length > 0) {
          const t = sanitizeSearchQuery(debouncedSearchTerm);

          const extraParams = [
            section ? `&section=${section}` : '',
            activeFilters.length > 0
              ? generateSearchQuery(activeFilters, section)
              : '',
          ].join('');

          const raw = await fetch(
            `/api/sok?phrase=${t}&size=${size}&page=${page}${extraParams}`,
          );
          const res = await raw.json();
          setSearchResult(res);
        }
      } catch (e) {
        setError(!!e);
      }
    })();
  }, [debouncedSearchTerm]);

  return {
    searchTerm,
    searchResult,
    setSearchTerm,
    error,
    debouncedSearchTerm,
  };
}
